import { NavLink } from 'react-router-dom';
import { useAuth, isAdmin, canSeeAuditLog, isBDM } from '../context/AuthContext';

const NAV = [
  { to: '/',             icon: 'ti-layout-dashboard', label: 'Dashboard',     roles: 'all' },
  { to: '/customers',    icon: 'ti-users',            label: 'Customers',     roles: 'all' },
  { to: '/products',     icon: 'ti-box',              label: 'Products',      roles: 'all' },
  { to: '/invoices',     icon: 'ti-file-invoice',     label: 'Invoices',      roles: 'all' },
  { to: '/azure',        icon: 'ti-cloud',            label: 'Azure Invoices',roles: 'accountant' },
  { to: '/sync',         icon: 'ti-refresh',          label: 'Sync Status',   roles: 'all' },
  { to: '/pricing',      icon: 'ti-coin',             label: 'Pricing',       roles: 'admin' },
  { to: '/analytics',    icon: 'ti-chart-bar',        label: 'Analytics',     roles: 'bdm' },
  { to: '/notifications',icon: 'ti-bell',             label: 'Notifications', roles: 'all' },
  { to: '/audit',        icon: 'ti-clipboard-list',   label: 'Audit Log',     roles: 'accountant' },
  { to: '/users',        icon: 'ti-shield-lock',      label: 'Users',         roles: 'admin' },
];

const ROLE_BADGE = {
  admin:      { label: 'Admin',      color: '#C9ADFF', bg: 'rgba(90,0,255,0.28)'   },
  accountant: { label: 'Accountant', color: '#6FE9B2', bg: 'rgba(47,213,138,0.18)' },
  bdm:        { label: 'BDM',        color: '#8FBFF5', bg: 'rgba(91,155,213,0.18)' },
  staff:      { label: 'Staff',      color: 'rgba(255,255,255,0.65)', bg: 'rgba(255,255,255,0.1)' },
};

export default function Sidebar() {
  const { user, logout } = useAuth();
  const role = user?.role || 'staff';
  const badge = ROLE_BADGE[role] || ROLE_BADGE.staff;

  const visible = (item) => {
    if (item.roles === 'all') return true;
    if (item.roles === 'admin') return isAdmin(user);
    if (item.roles === 'accountant') return canSeeAuditLog(user);
    if (item.roles === 'bdm') return isBDM(user);
    return true;
  };

  return (
    <aside className="sidebar" style={{ position: 'fixed', left: 0, top: 0, height: '100vh', zIndex: 100 }}>
      {/* Logo */}
      <div className="sidebar-logo">
        <div className="logo-mark"><span /><span /><span /><span /></div>
        <div>
          <div className="sidebar-logo-name">HYETECH</div>
          <div className="sidebar-logo-sub">PORTAL</div>
        </div>
      </div>

      {/* Nav */}
      <nav className="sidebar-nav">
        <div className="nav-section">Operations</div>
        {NAV.filter(visible).map(item => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
          >
            <i className={`ti ${item.icon}`} aria-hidden="true" />
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      {/* User */}
      <div className="sidebar-user">
        <div className="user-info">
          <div className="user-avatar">{user?.name?.charAt(0) || 'U'}</div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div className="user-name">{user?.name || 'User'}</div>
            <span className="role-chip" style={{ color: badge.color, background: badge.bg }}>
              {badge.label}
            </span>
          </div>
        </div>
        <button onClick={logout} className="logout-btn" title="Sign out">
          <i className="ti ti-power" aria-hidden="true" />
        </button>
      </div>
    </aside>
  );
}
